import React from 'react';

// bootstrap
import { Row, Col } from 'react-bootstrap';

// custom components
import { CustomToast } from '_atoms';
import TimelineTitles from '../timeline/timeline-components/timeline-titles';
import TimelineReportDashboard from './timeline-report-dashboard'
import TimelineReportBuilder from './timeline-report-builder';

// styling
import { Spacing } from '_styles';

const TimelineReportsIndex = (props) => {

    return (
        <Row style={{ }}>

            {/* Timeline Header */}
            <Col style={{ }}>

                <TimelineTitles isTimeline={false} isReportPage={true} />

                {/*<TimelineReportDashboard /> */}

                {/*<TimelineReportBuilder />*/}

                <TimelineReportDashboard />

                <CustomToast />
                
            </Col>

        </Row>
    );
};

export default TimelineReportsIndex;
